module.exports = __webpack_public_path__ + "static/media/method-2a-mob.467b01c9.png";